export const fields = [
  {
    key: 'date_transaction',
    label: 'Tanggal',
    thClass: 'align-middle',
    tdClass: 'align-top',
  },
  {
    key: 'transaction_type',
    label: 'Jenis Transaksi',
    thClass: 'align-middle',
    tdClass: 'align-top',
  },
  {
    key: 'amount',
    label: 'Jumlah',
    thClass: 'align-middle',
    tdClass: 'align-top',
  },
  {
    key: 'saldo',
    label: 'Saldo',
    thClass: 'align-middle',
    tdClass: 'align-top',
  },
  {
    key: 'action',
    label: '',
  },
]

export const ListFilterType = [
  { value: 1, label: 'Orderan COD Diterima', selected: false },
  { value: 2, label: 'Ongkir Non-COD', selected: false },
  { value: 3, label: 'Ongkir Non-COD Dibatalkan', selected: false },
  { value: 4, label: 'Tarik Saldo', selected: false },
  { value: 5, label: 'Top-up Saldo', selected: false },
  { value: 6, label: 'Retur COD', selected: false },
  { value: 7, label: 'Claim Retur Diterima', selected: false },
  { value: 8, label: 'Ganti Rugi Paket Hilang', selected: false },
  { value: 9, label: 'Ganti Rugi Paket Rusak', selected: false },
  { value: 10, label: 'Belanja Talent Komtim', selected: false },
  { value: 24, label: 'Invoice Komtim', selected: false },
  { value: 11, label: 'Pengembalian Dana Komtim', selected: false },
  { value: 12, label: 'Berlangganan Fitur', selected: false },
  {
    value: 13, label: 'Biaya Fulfillment', selected: false, product: 'kompack',
  },
  {
    value: 14, label: 'Pembatalan Fulfillment', selected: false, product: 'kompack',
  },
  {
    value: 16, label: 'Penarikan Barang', selected: false, product: 'kompack',
  },
  {
    value: 17, label: 'Pembatalan Penarikan Barang', selected: false, product: 'kompack',
  },
  {
    value: 15, label: 'Biaya Low Moving Stok', selected: false, product: 'kompack',
  },
  { value: 18, label: 'Asuransi', selected: false },
  { value: 19, label: 'Asuransi Dibatalkan', selected: false },
  {
    value: 33, label: 'Top-up Kredit Komed', selected: false, product: 'komed',
  },
  {
    value: 23, label: 'Top-up Saldo Komads', selected: false, product: 'komads',
  },
  {
    value: 27, label: 'Berlangganan Komads', selected: false, product: 'komads',
  },
  {
    value: 28, label: 'Virtual Account', selected: false, product: 'komchat',
  },
  {
    value: 29, label: 'QRIS', selected: false, product: 'komchat',
  },
]
